import { Card, Col, Row } from "react-bootstrap";
import Div from "../../../components/Div";
import PageTitle from "../../../components/PageTitle/index";
import { useEffect, useState } from "react";
import { DEV_URL, rpost } from "../../../utils/requests";
import { ContactsDataTable, AddressDataTable } from "./ContactInfo/index";
import { sortByProperty, filterRecords } from './../../../helpers/api/utils';
import loader from 'assets/images/datahub-loader.svg';

export const ContactInfo = ({ companyId, contacts }) => {
  const emptyContactsData = {contact:[]};
  const [companyContactData, setCompanyContactData] = useState(contacts || emptyContactsData);
  const [addressContactData, setAddressContactData] = useState();
  const [companyDataPage] = useState(1);
  const [companyDataPerPage] = useState(50);
  const [loadingAddresses, setLoadingAddresses] = useState(false);

  useEffect(() => {
    // Use contacts prop if provided
    if (contacts) {
      setCompanyContactData(contacts);
    }
  }, [contacts]);

  useEffect(() => {
    // Fetch addresses
    const fetchAddresses = async () => {
      setLoadingAddresses(true);
      try {
        const companyAddressResponse = await rpost(
            `${DEV_URL}/api/Address/getall`,
            {
                PageNumber: companyDataPage,
                PageSize: companyDataPerPage,
                SearchTerm: "",
                companyId: companyId,
            }
        );
        setAddressContactData(companyAddressResponse?.data);
      } catch (error) {
        console.error('Error fetching addresses:', error);
        setAddressContactData(null);
      } finally {
        setLoadingAddresses(false);
      }
    };
    if (companyId) {
      fetchAddresses();
    }
  }, [companyDataPage, companyDataPerPage, companyId]);
    const address = addressContactData?.filter(x => (x.contactAddress ?? '').trim() !== '');
  return (
    <span>
      <Div className="d-flex align-items-center justify-content-between">
        <PageTitle title={"Contacts"} />
      </Div>
      <Card className="">
        <Card.Body>
          <Row>
            <Col sm="12">
              {!contacts ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
                    <img src={loader} height={'50px'}/>
                </div>
              ) : (
                <ContactsDataTable
                  contacts={(sortByProperty(filterRecords(companyContactData?.contact, ['contactName', 'contactRole', 'contactEmail','contactPhone']), ['contactName']) )}
                  loading={false}
                />
              )}
            </Col>
          </Row>
        </Card.Body>
          </Card>
              <Div className="d-flex align-items-center justify-content-between">
                  <PageTitle title={"Addresses"} />
              </Div>
              <Card>
                  <Card.Body>
                      <Row>
                          <Col sm="12">
                              {loadingAddresses ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
                                    <img src={loader} height={'50px'}/>
                                </div>
                              ) : (
                                <AddressDataTable addresses={address} loading={false} />
                              )}
                          
                          </Col>
                      </Row>
                  </Card.Body>
              </Card>
      
    </span>
  );
};
